/**
 * Parse date string to timestamp (start or end of day).
 * Handles ISO strings and DD-MM-YYYY / DD/MM/YYYY. Returns NaN if invalid.
 */
function parseDateToTimestamp(
  input: any,
  { endOfDay = false }: { endOfDay?: boolean } = {},
): number {
  if (input == null || String(input).trim() === '') return NaN;
  const s = String(input).trim();
  let dt: Date = new Date(s);
  if (isNaN(dt.getTime())) {
    const m = s.match(/^(\d{1,2})[-/](\d{1,2})[-/](\d{4})$/);
    if (m) {
      const day = Number(m[1]);
      const mon = Number(m[2]) - 1;
      const yr = Number(m[3]);
      dt = new Date(yr, mon, day);
    } else {
      return NaN;
    }
  }
  if (!isNaN(dt.getTime())) {
    if (endOfDay) dt.setHours(23, 59, 59, 999);
    else dt.setHours(0, 0, 0, 0);
    return dt.getTime();
  }
  return NaN;
}

/**
 * AG Grid date "Between" filter predicate: cell value (single date or range)
 * matches filter range (open-ended allowed). Use as predicate in filterOptions.
 */
export function dateRangeFilterPredicate(cellValue: any, filterValues: any): boolean {
  if (cellValue !== 0 && !cellValue) return false;

  let startStr: string;
  let endStr: string;
  if (Array.isArray(filterValues)) {
    startStr = String(filterValues[0] ?? '').trim();
    endStr = String(filterValues[1] ?? '').trim();
  } else {
    const fv = String(filterValues ?? '');
    const parts = fv.split(' - ');
    startStr = (parts[0] ?? '').trim();
    endStr = (parts[1] ?? '').trim();
  }

  const tsStart = startStr ? parseDateToTimestamp(startStr, { endOfDay: false }) : -Infinity;
  const tsEnd = endStr ? parseDateToTimestamp(endStr, { endOfDay: true }) : Infinity;

  if (Number.isNaN(tsStart) || Number.isNaN(tsEnd)) return false;

  let c0: string;
  let c1: string;
  if (Array.isArray(cellValue)) {
    c0 = String(cellValue[0] ?? '').trim();
    c1 = String(cellValue[1] ?? '').trim();
  } else if (String(cellValue).includes(' - ')) {
    const parts = String(cellValue).split(' - ');
    c0 = (parts[0] ?? '').trim();
    c1 = (parts[1] ?? parts[0] ?? '').trim();
  } else {
    c0 = c1 = String(cellValue).trim();
  }

  const tsC0 = parseDateToTimestamp(c0, { endOfDay: false });
  const tsC1 = parseDateToTimestamp(c1, { endOfDay: true });
  if (Number.isNaN(tsC0) || Number.isNaN(tsC1)) return false;

  if (tsEnd !== Infinity && tsStart !== -Infinity) {
    return tsC0 <= tsStart && tsC1 >= tsEnd;
  }
  if (tsEnd === Infinity && tsStart !== -Infinity) {
    return tsC0 <= tsStart;
  }
  if (tsEnd !== Infinity && tsStart === -Infinity) {
    return tsC1 >= tsEnd;
  }
  return true;
}
